import React from 'react'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import {
  ForgotPasswordUi,
  ForgotPasswordWrapperUi,
} from 'common/components/entities/CustomLogin'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import usePage, { selectors as pageSelectors } from 'publisher/hooks/usePage'

type CustomLoginForgotPasswordProps = {
  entity: CustomLoginForgotPasswordInterface
}

function CustomLoginForgotPassword({ entity }: CustomLoginForgotPasswordProps) {
  const locale = usePage(pageSelectors.getLocale)
  return (
    <StyleWrapper
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <ForgotPasswordWrapperUi
        align={entity.textAlign || 'center'}
        mobileAlign={entity.mobileTextAlign || 'center'}
      >
        <ForgotPasswordUi {...entity} href={`/${locale}/restore-password`}>
          {entity.text}
        </ForgotPasswordUi>
      </ForgotPasswordWrapperUi>
    </StyleWrapper>
  )
}

export default CustomLoginForgotPassword
